import { render } from "./SysLogs.vue?vue&type=template&id=4bc91207"
import script from "./SysLogs.vue?vue&type=script&lang=js"
export * from "./SysLogs.vue?vue&type=script&lang=js"

import "./SysLogs.vue?vue&type=style&index=0&id=4bc91207&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__